export default "/assets/images/chart-02.svg?0d67fa6253da6f0093b3c6abebc746d2";